export default __webpack_public_path__ + "static/media/UZ.8fa6152f.svg";